import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/creators/{creatorId}/workflow-roles/{roleId}']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateCreatorWorkflowRole = async ({ creatorId, roleId, ...body }: Input): Promise<Output> => {
  const data = await noodleApiClient.put(`/creators/${creatorId}/workflow-roles/${roleId}`, body);
  return data.data;
};

export default updateCreatorWorkflowRole;
